export default "__VITE_ASSET__89c52dcf__"